import React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Select } from 'antd';
import QuickTurnBoltStore from 'stores/QuickTurnBoltStore';

const MaterialSelector = () => {
    const { material } = QuickTurnBoltStore;
    function handleChange(value: string) {
        QuickTurnBoltStore.updateBoltById(QuickTurnBoltStore.boltToken, { material: value });
    }

    return (
        <Form.Item label="Material" className="mb-0">
            <Select
                options={QuickTurnBoltStore.materials?.map(x => {
                    return {
                        label: x?.display_name,
                        value: x?.id,
                    };
                })}
                value={material}
                onChange={(value: string) => {
                    QuickTurnBoltStore.setMaterial(value);
                    handleChange(value);
                }}
            />
        </Form.Item>
    );
};

export default observer(MaterialSelector);
